/** System prompts sent to the music-generation companion (data channel / station bridge). */

export const MUSIC_GENERATION_COMPANION_MESSAGES = {
  lyricsReady:
    "The lyrics are ready and now visible on the user's screen. React to this naturally and invite them to read through the lyrics and share their thoughts.",
  lyricsRegenerated:
    "New lyrics have been generated and are now visible on the user's screen. React to the new lyrics and invite the user to share their thoughts.",
  coverArtPhase:
    'The user has moved to the cover art step. They can generate AI cover art or take a photo of themselves to be included. Help them decide.',
  songsGenerating:
    'The songs are now being created. Briefly acknowledge this. Do not try to fill time, the songs will be ready in seconds.',
  firstSongVariationReady:
    'The first song variation is ready. Do not announce this unprompted. If the user asks, let them know the first version is available.',
  secondSongVariationReady:
    'The second song variation is ready. Do not announce this unprompted. If the user asks, let them know the second version is available.',
  bothSongsComplete:
    'Both songs are complete! React with genuine excitement. Let the user know they can listen to each version of their song.',
  singleSongComplete:
    'Your song is complete! React with genuine excitement. Let the user know they can listen to their song.',
} as const;

export type CompanionSendMessagePayload = {
  type: 'send_message';
  data: {
    role: 'system';
    text: string;
    trigger_response: boolean;
    delay: boolean;
    state?: string;
    [key: string]: unknown;
  };
};

export function buildCompanionSendMessage(
  text: string,
  trigger_response: boolean,
  delay: boolean,
  extra?: Record<string, unknown>,
): CompanionSendMessagePayload {
  return {
    type: 'send_message',
    data: {
      role: 'system',
      text,
      trigger_response,
      delay,
      ...extra,
    },
  };
}
